import classNames from "classnames/bind";
import { OnlineCamera } from "../../../../components/Icons/Icons";
import styles from './MarkerCustom.module.css';
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { actions } from "../../../../store";
import { useStoreContext } from "../../../../hooks/useStoreContext";
import axiosClient from "../../../../services/axiosClient";
import { useContext, useEffect, useRef, useState } from "react";
import { MapContext } from "../../../../contexts";

const cx = classNames.bind(styles);

function MarkerCustom({ address, name,showLive,setShowLive, indexWareHouse, latitude, longitude }) {
    const {setWareCode} = useContext(MapContext)
    const refModal = useRef(null)
    const [show, setShow] = useState(false)
    // eslint-disable-next-line 
    const [dataStore, dispatch] = useStoreContext()
    const handleClickCamera = async () => {
       setShowLive(!showLive)
       setWareCode(indexWareHouse)
        
    }
    useEffect(() => {
        if (dataStore.viewPort && latitude === dataStore.viewPort.LATITUDE && longitude === dataStore.viewPort.LONGITUDE) {
            setShow(true)
        } else {
            setShow(false)
        }
    }, [dataStore.viewPort, latitude, longitude])

    useEffect(() => {
        if (show) {
            const handleCloseOnClickOutSide = (e) => {
                if (e.target !== refModal.current) {
                    setShow(false)
                }
            }
            document.addEventListener('click', handleCloseOnClickOutSide)
            return () => { document.removeEventListener('click', handleCloseOnClickOutSide) }
        }
    }, [refModal, show])

    return (
        <div className={cx('marker-container')} ref={refModal}>
            {show && (
                <div className={cx('info-camera-detail')}>
                    <h3 className={cx('name-camera')}>{name}</h3>
                    <p className={cx('title-camera')}>{address}</p>
                </div>
            )}
            {!show && (
                <div className={cx('info-camera')}>
                    <h3 className={cx('name-camera')}>{name}</h3>
                    <p className={cx('title-camera')}>{address}</p>
                </div>
            )}
            <button onClick={(e) => handleClickCamera(e)}>
                <OnlineCamera />
            </button>
        </div>
    )
}

MarkerCustom.propTypes = {
    address: PropTypes.string,
    name: PropTypes.string,
}

export default MarkerCustom;